import { render, staticRenderFns } from "./WantListMenu.vue?vue&type=template&id=01363028&scoped=true&"
import script from "./WantListMenu.vue?vue&type=script&lang=js&"
export * from "./WantListMenu.vue?vue&type=script&lang=js&"
import style0 from "./WantListMenu.vue?vue&type=style&index=0&id=01363028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01363028",
  null
  
)

export default component.exports